module.exports = __webpack_public_path__ + "img/love.55194188.png";